var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('h4', {
    class: _vm.$style.title
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('div', {
    class: _vm.$style.lang
  }, [_c('localization-controller', {
    attrs: {
      "language": _vm.language,
      "inverted-color": ""
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }